import { EmailStyleSettings } from "@/components/email-composer/style-settings";
import { TiptapEmailJSON } from "@/components/email-composer/types/tiptap-json";

interface EmailRenderRequest {
  doc: TiptapEmailJSON;
  settings?: Partial<EmailStyleSettings>;
  variables?: Record<string, string>;
  plainText?: boolean;
  /** "marketing" (default, blasts) or "conversational" (reply/forward/compose). */
  variant?: "marketing" | "conversational";
}

/**
 * Render a Tiptap email document to HTML or plain text via the server-side
 * Next.js route handler. This keeps `@react-email/render` (which depends on
 * `react-dom/server`) out of the client bundle.
 */
export async function renderEmail(
  request: EmailRenderRequest,
): Promise<string> {
  const res = await fetch("/api/email/render", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(request),
  });

  if (!res.ok) {
    throw new Error(`Email render failed: ${res.status}`);
  }

  const data = await res.json();
  return data.result;
}
